import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

export default function useFetchServiceTokens(page, enabled) {
    const { accessToken } = useTokenStore();
    return useQuery(["service-tokens", page], async () => {
        const api = await InitApi({ accessToken });
        const response = await api.get("/admin/service-tokens", { params: { page } });
        return response.data.data;
    }, { enabled, cacheTime: 0, staleTime: 0, retry: 1 });
}
